import { jsx as _jsx } from "react/jsx-runtime";
import { WalletMenuProvider } from '../WalletMenuProvider/WalletMenuProvider.js';
import { WalletManagementContext, initialContext, } from './WalletManagementContext.js';
export const WalletManagementProvider = ({ children, config = initialContext }) => {
    return (_jsx(WalletManagementContext.Provider, { value: config, children: _jsx(WalletMenuProvider, { children: children }) }));
};
//# sourceMappingURL=WalletManagementProvider.js.map